import React, { useState } from "react";
import image from "../../assets/images/login-imge.png";
import { Link } from "react-router-dom";
import Popup from "./Popup";
import { api } from "../../Constant";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Register = () => {
  const navigation = useNavigate();

  const location = useLocation();
  const { product_id, size, quantity } = location.state || {};

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    password_confirmation: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupTitle, setPopupTitle] = useState("Notification");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setPopupMessage(""); // Clear previous message

    try {
      const response = await fetch(api + "register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // Successful registration
        localStorage.setItem("userPhone", formData.phone);
        localStorage.setItem("userEmail", formData.email);

        setPopupTitle("Success");
        setPopupMessage("Registration successful! Please log in.");

        setFormData({
          name: "",
          email: "",
          phone: "",
          password: "",
          password_confirmation: "",
        });

        setShowPopup(true); // Show the popup
        navigation("/Login-Page", {
  state: {
    product_id,
    size,
    quantity
  }
});

      } else {
        // Handle errors based on your API response
        if (data.success === "false" && data.error) {
          const errorMessages = Object.values(data.error).flat().join(" ");
          setPopupTitle("Error");
          setPopupMessage(errorMessages || "Registration failed");
          setShowPopup(true); // Show the popup
        } else {
          setPopupTitle("Error");
          setPopupMessage(data.message || "Registration failed");
          setShowPopup(true); // Show the popup
        }
      }
    } catch (error) {
      setPopupTitle("Error");
      setPopupMessage("An error occurred. Please try again.");
      setShowPopup(true); // Show the popup
    }
  };


  const handleGuestLogin = async () => {
    const storedGuestId = localStorage.getItem('guest_id');
    if (storedGuestId) {
      // Returning guest
      localStorage.setItem('userId', storedGuestId);
      localStorage.setItem('userName', 'Guest');
      localStorage.setItem('hasShownPopup', '');
      setPopupTitle('Guest Login');
      setPopupMessage('Welcome back, Guest!');
      setShowPopup(true);
  
      setTimeout(() => {
        navigation('/');
      }, 1000);
    } else {
      // New guest
      try {
        const response = await fetch(api + 'get_guest_id');
        const data = await response.json();
  
        console.log("Guest API Response:", data); // ✅ Debug
  
        if (response.ok && (data.success === true || data.success === "true")) {
          localStorage.setItem('guest_id', data.guest_id.toString()); // ensure it's a string
          localStorage.setItem('userId', data.guest_id.toString());
          localStorage.setItem('userName', 'Guest');
          localStorage.setItem('hasShownPopup', '');
          setPopupTitle('Guest Login');
          setPopupMessage(data.message || 'You are logged in as a Guest.');
          setShowPopup(true);
  
          setTimeout(() => {
            navigation('/');
          }, 1000);
        } else {
          setPopupTitle('Error');
          setPopupMessage(data.message || 'Unable to login as Guest');
          setShowPopup(true);
        }
      } catch (error) {
        console.error("Guest login error:", error);
        setPopupTitle('Error');
        setPopupMessage('Something went wrong during guest login.');
        setShowPopup(true);
      }
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="login-page-bg pt-80 pb-80">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 register-imge login-img">
            <div className="img">
              <img src={image} alt="Registration" />
            </div>
            <div className="login-form">
              <div className="row">
                <div className="col-lg-12 register-title title">
                  <h3>Register</h3>
                </div>
              </div>
              <form className="row" onSubmit={handleSubmit}>
                <div className="col-lg-12">
                  <label>
                    Name<sup>*</sup>
                  </label>
                  <br />
                  <input
                    name="name"
                    placeholder="Enter Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-12">
                  <label>
                    Email Id <sup>*</sup>
                  </label>
                  <br />
                  <input
                    name="email"
                    placeholder="Enter Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-12">
                  <label>
                    Phone Number<sup>*</sup>
                  </label>
                  <br />
                  <input
                    name="phone"
                    placeholder="Enter Your Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    maxLength="10"
                  />
                </div>
                <div className="col-lg-12">
                  <label>
                    Password <sup>*</sup>
                  </label>
                  <br />
                  <input
                    name="password"
                    type="password"
                    placeholder="Enter Your Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-12">
                  <label>
                    Confirm Password <sup>*</sup>
                  </label>
                  <br />
                  <input
                    name="password_confirmation"
                    type="password"
                    placeholder="Confirm Your Password"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-12">
                  <button type="submit">Submit</button>
                </div>
                <div className="col-lg-12 already-acc">
                  <p>Already have an Account?</p>
                  <Link to="/Login-Page">Login</Link>
                </div>

                <div className="col-lg-12 already-acc">
         <h5 type=" text-primary font-weight-bold" onClick={handleGuestLogin} style={{ cursor: 'pointer' , color: '#227070'}}>
                                        Guest Login
                                    </h5>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showPopup && (
        <Popup
          message={popupMessage}
          title={popupTitle}
          onClose={closePopup}
          type={popupTitle === "Success" ? "success" : "error"} // Pass type based on title
        />
      )}
    </div>
  );
};

export default Register;
